// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__25CXb","content":"styles_content__2ULAY","selectAll":"styles_selectAll__2Yx-L"};